<template>
    <div id="total_power_consumption">
      <el-scrollbar :class="isCollapse?'menu_hide rightSide':'rightSide'">
        <el-main>
          <el-breadcrumb separator-class="el-icon-arrow-right" class="mainBread">
            <el-breadcrumb-item :to="{ path: '/' }">{{ $t('HomePage') }}</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/' }">{{ $t('ReportingMgmt') }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{ $t('TotalPowerConsumptionStatistics') }}</el-breadcrumb-item>
          </el-breadcrumb>
          <el-form ref="form" :model="form" label-width="80px" class="queryform_div">
            <el-form-item :label="$t('Campus')">
              <el-input v-model="form.garden" class="queryform"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Build')">
              <el-input v-model="form.building" class="queryform"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Function')">
              <el-input v-model="form.functions" class="queryform"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Lab')">
              <el-input v-model="form.laboratory" class="queryform"></el-input>
            </el-form-item>
            <el-form-item :label="$t('GradeOfElectricMeter')">
              <el-input v-model="form.ele_rank" class="queryform"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Meter')">
              <el-input v-model="form.electricity_meter" class="queryform"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Years')">
              <el-date-picker v-model="form.selectYearMonth" type="month" :placeholder="$t('SelectYearAndMonth')" value-format="yyyy-MM"></el-date-picker>
<!--              <el-select v-model="find_year" :placeholder="$t('el.select.placeholder')" class="queryform">-->
<!--                <el-option>2020年</el-option>-->
<!--                <el-option>2019年</el-option>-->
<!--                <el-option>2018年</el-option>-->
<!--                <el-option>2017年</el-option>-->
<!--                <el-option>2016年</el-option>-->
<!--              </el-select>-->
            </el-form-item>
<!--            <el-form-item label="月">-->
<!--              <el-select v-model="find_month" :placeholder="$t('el.select.placeholder')" class="queryform">-->
<!--                <el-option>8月</el-option>-->
<!--                <el-option>7月</el-option>-->
<!--                <el-option>6月</el-option>-->
<!--                <el-option>5月</el-option>-->
<!--                <el-option>4月</el-option>-->
<!--                <el-option>3月</el-option>-->
<!--                <el-option>2月</el-option>-->
<!--                <el-option>1月</el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
            <el-form-item>
              <el-button type="primary" @click="conlog">{{ $t('Query') }}</el-button>
              <el-button>{{ $t('Cancel') }}</el-button>
            </el-form-item>
          </el-form>

          <template>
            <h3>{{ $t('TotalPowerConsumptionStatistics') }}</h3>
            <el-table :data="tableData1"
                      style="width: 100%">

              <el-table-column :label="$t('Location')"
                               width="150">
                <template slot-scope="scope">
                  <el-button size="mini"
                             type="primary"
                             @click="dialogChart1 = true">
                    {{scope.row.address}}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column prop="year"
                               label="2020年"
                               width="100">
              </el-table-column>
              <el-table-column prop="month1"
                               label="2020.1">
              </el-table-column>
              <el-table-column prop="month2"
                               label="2020.2">
              </el-table-column>
              <el-table-column prop="month3"
                               label="2020.3">
              </el-table-column>
              <el-table-column prop="month4"
                               label="2020.4">
              </el-table-column>
              <el-table-column prop="month5"
                               label="2020.5">
              </el-table-column>
              <el-table-column prop="month6"
                               label="2020.6">
              </el-table-column>
              <el-table-column prop="month7"
                               label="2020.7">
              </el-table-column>
              <el-table-column prop="month8"
                               label="2020.8">
              </el-table-column>
              <el-table-column prop="month9"
                               label="2020.9">
              </el-table-column>
              <el-table-column prop="month10"
                               label="2020.10">
              </el-table-column>
              <el-table-column prop="month11"
                               label="2020.11">
              </el-table-column>
              <el-table-column prop="month12"
                               label="2020.12">
              </el-table-column>
            </el-table>
          </template>

          <template>
            <h3>{{ $t('ElectricityConsumption') }}</h3>
            <el-table :data="tableData2" style="width: 100%">

              <el-table-column prop="address"
                               :label="$t('Location')" width="150">
              </el-table-column>
              <el-table-column prop="building"
                               :label="$t('Build')" width="150">
              </el-table-column>
              <el-table-column :label="$t('ElectricityConsumptionUnit')"
                               width="150">
                <template slot-scope="scope">
                  <el-button size="mini"
                             type="primary"
                             @click="dialogChart2 = true">
                    {{scope.row.eleOne}}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column prop="year"
                               label="2020">
              </el-table-column>
              <el-table-column prop="month1"
                               label="2020.1">
              </el-table-column>
              <el-table-column prop="month2"
                               label="2020.2">
              </el-table-column>
              <el-table-column prop="month3"
                               label="2020.3">
              </el-table-column>
              <el-table-column prop="month4"
                               label="2020.4">
              </el-table-column>
              <el-table-column prop="month5"
                               label="2020.5">
              </el-table-column>
              <el-table-column prop="month6"
                               label="2020.6">
              </el-table-column>
              <el-table-column prop="month7"
                               label="2020.7">
              </el-table-column>
              <el-table-column prop="month8"
                               label="2020.8">
              </el-table-column>
              <el-table-column prop="month9"
                               label="2020.9">
              </el-table-column>
              <el-table-column prop="month10"
                               label="2020.10">
              </el-table-column>
              <el-table-column prop="month11"
                               label="2020.11">
              </el-table-column>
              <el-table-column prop="month12"
                               label="2020.12">
              </el-table-column>
            </el-table>
          </template>
        </el-main>
      </el-scrollbar>

      <el-dialog :title="$t('Headquarters') + '- ' + $t('MonthOnMonthElectricity')" :visible.sync="dialogChart1" width="70%" top="10vh">
        <template>
          <div class="ChartsDiv" style="height:300px;width:100%;">
            <img src="~assets/img/charts.jpg" style="width:100%"  alt="Failed to load image"/>
          </div>
        </template>

      </el-dialog>
      <el-dialog :title="$t('ElectricityConsumptionUnit') + '1#HFYURFDHR - ' + $t('MonthOnMonthElectricity')" :visible.sync="dialogChart2" width="70%" top="10vh">
        <template>
          <div class="ChartsDiv" style="height:300px;width:100%;">
            <img src="~assets/img/charts2.jpg" style="width:100%"  alt="Failed to load image"/>
          </div>
        </template>
      </el-dialog>
    </div>
</template>

<script>
  import {mapState} from 'vuex';
    export default {
        name: "Total_power_consumption",
      data() {
          return {
            form:{
              garden:"",
              building:"",
              functions:"",
              laboratory:"",
              ele_rank:"",
              electricity_meter:"",
              selectYearMonth:""
            },
            dialogChart1: false,
            dialogChart2: false,
            tableData1: [{
              address: this.$t('Headquarters'),
              year: '245,852,365',
              month1: '2,154,664',
              month2: '2,658,464',
              month3: '2,584,942',
              month4: '2,988,774',
              month5: '1,988,777',
              month6: '2,545,475',
              month7: '2,658,987',
              month8: '2,154,664',
              month9: '2,658,987',
              month10: '2,154,664',
              month11: '2,545,475',
              month12: '2,988,774'
            }],
            tableData2: [{
              address: this.$t('Headquarters'),
              building: 'B1' + this.$t('FactoryArea'),
              eleOne: '1#HFYURFDHR',
              year: '458,952',
              month1: '4,525',
              month2: '1,258',
              month3: '3,254',
              month4: '1,254',
              month5: '1,252',
              month6: '1,025',
              month7: '1,987',
              month8: '958',
              month9: '1,215',
              month10: '1,258',
              month11: '1,654',
              month12: '145'
            }, {
              address: this.$t('Headquarters'),
              building: 'B1' + this.$t('FactoryArea'),
              eleOne: '1#BSHFDYFBDH',
              year: '2',
              month1: '0',
              month2: '0',
              month3: '0',
              month4: '0',
              month5: '0',
              month6: '0',
              month7: '0',
              month8: '0',
              month9: '0',
              month10: '0',
              month11: '2',
              month12: '0'
            }, {
              address: this.$t('Headquarters'),
              building: 'B1' + this.$t('FactoryArea'),
              eleOne: '1#BDGEYFJF',
              year: '0',
              month1: '0',
              month2: '0',
              month3: '0',
              month4: '0',
              month5: '0',
              month6: '0',
              month7: '0',
              month8: '0',
              month9: '0',
              month10: '0',
              month11: '0',
              month12: '0'
            }]
          }
      },
      methods: {
        conlog(){
          // console.log(typeof (this.form.selectYearMonth))
        },
        openNotice() {
          this.$notify({
            title: this.$t('warn'),
            message: this.$t('warningMessage'),
            type: 'warning'
          });
        }
      },
      computed:mapState({
        isCollapse:state=>state.isCollapse
      }),
    }
</script>

<style scoped>

</style>
